import { render, staticRenderFns } from "./ChannelInfo.vue?vue&type=template&id=745ea2a8"
import script from "./ChannelInfo.vue?vue&type=script&lang=js"
export * from "./ChannelInfo.vue?vue&type=script&lang=js"
import style0 from "./ChannelInfo.vue?vue&type=style&index=0&id=745ea2a8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports